export const normalizeActions = (actions: string[]): { id: number; name: string }[] =>
  (actions ?? []).map((action, index) => ({
    id: index,
    name: action,
  }));

export const sanitizeFileName = (fileName: string) => fileName.replace(/\.[^/.]+$/, '').replace(/\s+/g, '');

export const reportFileName = (url: string) => {
  const path = url.split('?')[0].split('#')[0];
  const raw = path.split('/').filter(Boolean).pop() || '';
  try {
    return decodeURIComponent(raw) || 'View report';
  } catch {
    return raw || 'View report';
  }
};

export const formatFileSize = (bytes?: number) => {
  if (!bytes) return '';
  if (bytes < 1024) return `Size: ${bytes} B`;
  if (bytes < 1024 * 1024) return `Size: ${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `Size: ${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const uploadedAgo = (iso?: string | null, now = Date.now()) => {
  if (!iso) return '';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  const days = Math.floor((now - then) / 86400000);
  if (days <= 0) return 'Uploaded today';
  if (days === 1) return 'Uploaded: 1 day ago';
  return `Uploaded: ${days} days ago`;
};
